import { jwtDecode } from "jwt-decode"
import { API_ROUTES } from "../../configuration/RoutesApi"

export type JwtPayload = {
  permission?: string[]
}

export function getPermissions(): string[] {
  const token = localStorage.getItem(API_ROUTES.TOKEN)

  if (!token) {
    return []
  }

  const decoded = jwtDecode<JwtPayload>(token)

  return decoded.permission ?? []
}

export function usePermission(permission: string) {
  const permissions = getPermissions()

  return permissions.includes(permission)
}
